"use client";
import { useState, useRef, useEffect } from "react";
import { ChevronDown } from "lucide-react";

interface DropdownProps {
  label: string;
  items: { id: string; label: string }[];
  onSelect: (id: string) => void;
}

export default function Dropdown({ label, items, onSelect }: DropdownProps) {
  const [open, setOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  // Close on outside click
  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node)
      ) {
        setOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div className="relative" ref={dropdownRef}>
      <button
        onClick={() => setOpen(!open)}
        className="action hover:bg-leaf-green text-md flex items-center space-x-1 text-gray-700 hover:text-white px-3 py-1 rounded-md transition"
      >
        <span>{label}</span>
        {open ? <ChevronDown className="w-4 h-4 rotate-180" /> : <ChevronDown className="w-4 h-4" />}
      </button>

      {open && (
        <div className="absolute right-0 mt-2 w-48 bg-white/95 backdrop-blur-xl border border-white/20 rounded-md shadow-lg z-50">
          <ul className="py-1 text-sm text-gray-800">
            {items.map((item) => (
              <li
                key={item.id}
                onClick={() => {
                  onSelect(item.id);
                  setOpen(false);
                }}
                className="cursor-pointer px-4 py-2 hover:bg-amber-100 transition"
              >
                {item.label}
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
}
